import Image from '@components/ui/image';
import { generateCartItemName } from '@utils/generate-cart-item-name';
import usePrice from '@framework/product/use-price';
import { getProductImageUrl } from '@framework/product/get-product-image';
import Counter from '@components/ui/counter';
import { useCart } from '@contexts/cart/cart.context';
import { IoMdCloseCircle } from 'react-icons/io';
import { CartItem } from '@utils/generate-cart-item';
import { getNameForLanguage } from '@framework/types';

export const CheckoutItem: React.FC<{ item: CartItem; lang: string }> = ({
  item,
  lang,
}) => {
  const productImage = getProductImageUrl(item);
  const { price: totalPrice } = usePrice({
    amount: item.itemTotal as number,
    currencyCode: 'EUR',
  });

  const { price: pricePerItem } = usePrice({
    amount: item.price,
    currencyCode: 'EUR',
  });

  const { isInStock, addItemToCart, removeItemFromCart, clearItemFromCart } =
    useCart();
  const outOfStock = !isInStock(item.id, item.batch_id);

  return (
    <div
      className="flex items-center py-4 border-b border-border-base"
      style={{ columnGap: 15 }}
    >
      <div
        className="cursor-pointer"
        onClick={() => clearItemFromCart(item.id, item.batch_id)}
      >
        <IoMdCloseCircle color="red" size={20} />
      </div>
      <div className="flex w-16 h-16 border rounded-md border-border-base shrink-0">
        <Image
          src={productImage}
          alt={'item image'}
          className="rounded-md ltr:mr-5 rtl:ml-5"
          width={64}
          height={64}
          style={{ width: 'auto', objectFit: 'contain' }}
        />
      </div>
      <h6 className="font-normal text-15px text-brand-dark ltr:pl-3 rtl:pr-3">
        {item.id}
      </h6>
      <h6 className="font-normal text-15px text-brand-dark ltr:pl-3 rtl:pr-3">
        {generateCartItemName(
          getNameForLanguage(item, lang),
          item.attributes as any,
        )}
      </h6>
      <div
        className="font-medium ltr:ml-auto rtl:mr-auto shrink-0 text-15px text-brand-dark"
        style={{ width: 90 }}
      >
        {pricePerItem}
      </div>
      <div className="font-medium shrink-0 text-15px text-brand-dark">
        <Counter
          value={item.quantity!}
          maxValue={item.stock!}
          onIncrement={() => addItemToCart(item, +item.quantity! + 1)}
          onDecrement={() => removeItemFromCart(item.id, item.batch_id)}
          onValueChange={(quantity) => addItemToCart(item, quantity)}
          editableInput={true}
          variant="cart"
          disabled={outOfStock}
          lang={lang}
        />
      </div>
      <div
        className="flex font-normal text-15px text-brand-dark ltr:pl-2 rtl:pr-2 shrink-0"
        style={{ width: 90 }}
      >
        {totalPrice}
      </div>
    </div>
  );
};
